import React, { Component } from 'react';
import { Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { Trans } from "react-i18next";   
import "../../../../config/i18n";
import { withTranslation } from "react-i18next";

class ChangeePassword extends Component {
    constructor(props) {
        super(props);
        this.onChangepswd = this.onChangepswd.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this.state = {
            old_pswd:'',new_pswd:'',retype_pswd:'',successMessage:''
        }
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
    }

    handleInputChange(event) {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    }

    onChangepswd(e){
        const apiUrl = localStorage.getItem('api_url');
        e.preventDefault();
        if(this.state.old_pswd !== this.state.new_pswd){
            if(this.state.new_pswd === this.state.retype_pswd){
                var change_password = new FormData();
                change_password.set('user_id',JSON.parse(localStorage.getItem('session_userid')));
                change_password.set('old_password', this.state.old_pswd);
                change_password.set('new_password', this.state.new_pswd);
                change_password.set('language', 'en'); 
                    axios({
                        method: 'post',
                        url: apiUrl+'webchangepassword',
                        data: change_password,
                        config: { headers: {'Content-Type': 'multipart/form-data' }}
                                    })
                .then(res => {
                    const message = res.data.message;
                    if(res.data.status === 'true'){
                        this.setState({
                            old_pswd: '',
                            new_pswd:'',
                            retype_pswd:'',
                            successMessage: message,
                            suc_cls: 'successMsg floatingAlerts1',
                        });

                    } else{
                        this.setState({
                            successMessage: message,
                            suc_cls: 'successMsg floatingAlerts1',
                        });
                    }
                    setTimeout(() => {
                        this.setState({
                            suc_cls: 'successMsghide'
                        });
                    }, 5000); 
                })
            }else{
                this.setState({
                    successMessage: "New Password and Re-type password must be same",
                    suc_cls: 'successMsg floatingAlerts1',
                });
                setTimeout(() => {
                    this.setState({
                        suc_cls: 'successMsghide'
                    });
                }, 5000); 
            }
        }else{
            this.setState({
                successMessage: "New Password and Old password must not be same",
                suc_cls: 'successMsg floatingAlerts1',
            });
            setTimeout(() => {
                this.setState({
                    suc_cls: 'successMsghide'
                });
            }, 5000);
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div className=''>
                <div className='setting_tab_title'>
                    <div className='whole_information'>
                        {this.state.successMessage && (
                            <div className={this.state.suc_cls}>
                                {this.state.successMessage}
                            </div>
                        )}
                    </div>
                    <h4><Trans i18nKey="Change your password">Change your password</Trans></h4>
                </div>
                <div className='changepwd_form'>
                    <Form.Group controlId="formPlaintextEmail" className="">
                        <Form.Control name="old_pswd" placeholder={t("Old password")} value={this.state.old_pswd} type="password" onChange={this.handleInputChange} required />
                    </Form.Group>
                    <Form.Group controlId="formPlaintextEmail" className="">
                        <Form.Control name="new_pswd" placeholder={t("New password")} value={this.state.new_pswd} type="password" onChange={this.handleInputChange} required />
                    </Form.Group>
                    <Form.Group controlId="formPlaintextEmail" className="">
                        <Form.Control name="retype_pswd" placeholder={t("Confirm password")} value={this.state.retype_pswd} type="password" onChange={this.handleInputChange} required/>
                    </Form.Group>

                </div>
                <div className='chang_pwd_margin'>
                    <Button className='button_primary' onClick={this.onChangepswd}><Trans i18nKey="CHANGE PASSWORD">CHANGE PASSWORD</Trans></Button>
                </div>
            </div>
        );
    }
}

export default withTranslation("translations")(ChangeePassword);
